import script from "./SolutionView2.vue?vue&type=script&lang=ts&setup=true"
export * from "./SolutionView2.vue?vue&type=script&lang=ts&setup=true"

import "./SolutionView2.vue?vue&type=style&index=0&id=39affc8b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39affc8b"]])

export default __exports__